// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { AlarmeService } from "./alarme.service"
import { ChauffageService } from "./chauffage.service"
import { DashboardEmService } from "./dashboard-em.service"
import { EnergyManagerService } from "./energy-manager.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./alarme.service"
export * from "./chauffage.service"
export * from "./dashboard-em.service"
export * from "./energy-manager.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const energyManagerServiceRegistry = {
    alarme: new AlarmeService(),
    chauffage: new ChauffageService(),
    dashboardEm: new DashboardEmService(),
    energyManager: new EnergyManagerService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type EnergyManagerServiceRegistry = typeof energyManagerServiceRegistry
